var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReservation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "date 1",
    clipPath: "url(#clip0_0_3723)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_3723",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 40
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bg",
    d: "M40.5 0H0.5V40H40.5V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path85",
    d: "M9.5625 21.0938H6.4375V17.9688H9.5625V21.0938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path87",
    d: "M15.8125 21.0938H12.6875V17.9688H15.8125V21.0938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path89",
    d: "M22.0625 21.0938H18.9375V17.9688H22.0625V21.0938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path91",
    d: "M28.3125 21.0938H25.1875V17.9688H28.3125V21.0938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path93",
    d: "M34.5625 21.0938H31.4375V17.9688H34.5625V21.0938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path95",
    d: "M9.5625 27.3438H6.4375V24.2188H9.5625V27.3438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path97",
    d: "M15.8125 27.3438H12.6875V24.2188H15.8125V27.3438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path99",
    d: "M22.0625 27.3438H18.9375V24.2188H22.0625V27.3438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path101",
    d: "M9.5625 33.5938H6.4375V30.4688H9.5625V33.5938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path103",
    d: "M15.8125 33.5938H12.6875V30.4688H15.8125V33.5938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path105",
    d: "M22.0625 33.5938H18.9375V30.4688H22.0625V33.5938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path113",
    d: "M29.875 24.0585L31.4684 27.223L35.0312 27.7305L32.4531 30.1937L33.0617 33.6719L29.875 32.0297L26.6883 33.6719L27.2969 30.1937L24.7188 27.7305L28.2816 27.223L29.875 24.0585Z",
    fill: "white"
  }))))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_3723)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g65"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_3723",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 40
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "clipPath71"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path69",
    d: "M0.5 3.8147e-06H40.5V40H0.5V3.8147e-06Z",
    fill: "white"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_3723)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g67"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g73"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path75",
    d: "M35.8125 38.4375H5.1875C3.46164 38.4375 2.0625 37.0384 2.0625 35.3125V7.8125C2.0625 6.08664 3.46164 4.6875 5.1875 4.6875H35.8125C37.5384 4.6875 38.9375 6.08664 38.9375 7.8125V35.3125C38.9375 37.0384 37.5384 38.4375 35.8125 38.4375Z",
    stroke: "#111111",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "g77"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path79",
    d: "M8.625 7.8125V1.5625",
    stroke: "#111111",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g81"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path83",
    d: "M32.375 1.5625V7.8125",
    stroke: "#111111",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path85_2",
    d: "M9.5625 21.0938H6.4375V17.9688H9.5625V21.0938Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path87_2",
    d: "M15.8125 21.0938H12.6875V17.9688H15.8125V21.0938Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path89_2",
    d: "M22.0625 21.0938H18.9375V17.9688H22.0625V21.0938Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path91_2",
    d: "M28.3125 21.0938H25.1875V17.9688H28.3125V21.0938Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path93_2",
    d: "M34.5625 21.0938H31.4375V17.9688H34.5625V21.0938Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path95_2",
    d: "M9.5625 27.3438H6.4375V24.2188H9.5625V27.3438Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path97_2",
    d: "M15.8125 27.3438H12.6875V24.2188H15.8125V27.3438Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path99_2",
    d: "M22.0625 27.3438H18.9375V24.2188H22.0625V27.3438Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path101_2",
    d: "M9.5625 33.5938H6.4375V30.4688H9.5625V33.5938Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path103_2",
    d: "M15.8125 33.5938H12.6875V30.4688H15.8125V33.5938Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path105_2",
    d: "M22.0625 33.5938H18.9375V30.4688H22.0625V33.5938Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g107"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path109",
    d: "M2.0625 13.125H38.9375",
    stroke: "#111111",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path113_2",
    d: "M29.875 24.0585L31.4684 27.223L35.0312 27.7305L32.4531 30.1937L33.0617 33.6719L29.875 32.0297L26.6883 33.6719L27.2969 30.1937L24.7188 27.7305L28.2816 27.223L29.875 24.0585Z",
    fill: "#111111"
  })))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_3723"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservation);
export default __webpack_public_path__ + "static/media/reservation.2f653696c8fbabb088ed1f1eb6b92aaf.svg";
export { ForwardRef as ReactComponent };